import { enMessages } from "./enMessages";
import { ruMessages } from "./ruMessages";

export const messagesDict = {
    ru: ruMessages,
    en: enMessages
}